import React, { useState, useEffect, useRef } from "react";
import TabNavigation from "./TabNavigation";
import TabContent from "./TabContent";

const RoofingOptions = ({ roofingItem, availableOptions }) => {
  const [formData, setFormData] = useState(roofingItem || {});
  const [activeTab, setActiveTab] = useState("job_photos");
  const fileInputRef = useRef(null);

  const tabs = ["job_photos"];

  const handleChange = (field, value) => {
    setFormData((prev) => {
      const updated = {};
      Object.keys(prev).forEach((key) => {
        updated[key] = prev[key];
      });
      updated[field] = value;
      return updated;
    });
  };

  // Update file input when job_photos changes
  useEffect(() => {
    if (
      fileInputRef.current &&
      formData.job_photos &&
      formData.job_photos.length > 0
    ) {
      const dataTransfer = new DataTransfer();
      formData.job_photos.forEach((file) => {
        if (file instanceof File) {
          dataTransfer.items.add(file);
        }
      });
      fileInputRef.current.files = dataTransfer.files;
    }
  }, [formData.job_photos]);

  return (
    <div className="space-y-4" data-testid="roofing-options">
      <div className="p-2 bg-lighter rounded">
        <TabNavigation
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        <TabContent
          activeTab={activeTab}
          formData={formData}
          onChange={handleChange}
        />
      </div>

      {/* File input for job photos */}
      <input
        ref={fileInputRef}
        type="file"
        name="sales_roofing_item[job_photos][]"
        multiple
        style={{ display: "none" }}
      />

      {/* Hidden inputs for photos to remove */}
      {formData.job_photos_to_remove &&
        formData.job_photos_to_remove.map((photoId, index) => (
          <input
            key={"photo-to-remove-" + index}
            type="hidden"
            name="sales_roofing_item[job_photos_to_remove][]"
            value={photoId}
          />
        ))}
    </div>
  );
};

export default RoofingOptions;
